module.exports = __webpack_public_path__ + "static/sticker-recycle-f160585ac63571982899bbd7712e894d.svg";